/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { NotificationContextData } from '../interfaces';

export const NotificationContext = React.createContext<NotificationContextData>({} as NotificationContextData);
